/**
 * Canonical redundancy options for cooling/CDU (aligned with server `REDUNDANCY_OPTIONS`).
 */
export const REDUNDANCY_OPTIONS = ['N', 'N+1', '2N'] as const;
export type RedundancyOption = (typeof REDUNDANCY_OPTIONS)[number];
